import {Directive, Input, HostBinding, HostListener, forwardRef, Inject} from "@angular/core";
import {SuggestionsComponent} from "./hints.component";


export class Hint {

     data: any;
    prev: Hint;
    next: Hint;
     selected: boolean = false;

    constructor( private  parent: SuggestionsComponent) {
    }

     click(): void {
        this.parent.select(this);
    }

    activate(): void {
        this.selected = true;
    }

    deactivate(): void {
        this.selected = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
    selector: "[a2ui-hint]"
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: SuggestionsComponent, decorators: [{ type: Inject, args: [forwardRef(() => SuggestionsComponent), ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'data': [{ type: Input, args: ["data", ] },],
'selected': [{ type: HostBinding, args: ["class.active", ] },],
'click': [{ type: HostListener, args: ["click", ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
